import styles from '../components/Ordertable.module.css'
import { useEffect, useRef, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { addDays, differenceInDays } from 'date-fns';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import swal from 'sweetalert';
import { Link } from "react-router-dom"
import { dbService, storageService } from 'fbase';
import { addDoc, collection } from "firebase/firestore";
import Navigation from 'components/Navigation';
import { faL } from '@fortawesome/free-solid-svg-icons';
import { ref, uploadString, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

function CreateProduct({userObj, isLoggedIn}){
    const form = useRef();
    const postProduct = (e) => {
        e.preventDefault();
        onSubmit().then(swal("캐리어 정보를 업로드하였습니다!", "","success").then((okay)=>{
            window.location.replace(process.env.PUBLIC_URL + "/account/createproduct/");
        }))
    }
    const onSubmit = async (e) => {
        // let attachmentUrl = "";
        // if(attachment !== ""){
        //     const attachmentRef = ref(storageService, `/${uuidv4()}`)
        //     const respose = await uploadString(attachmentRef, attachment, "data_url")
        //     attachmentUrl = await getDownloadURL(respose.ref);
        // }
        const productObj = {
            ...inputs,
            rentalNum: 0,
            dc: false,
            reserv_date: null,
            return_date: null,
            repair: false,
            damage: false,
            zip,
            extension,
            sidehandle,
            tsa,
            imgSrc: [],
            createdTime: Date.now()
        }
        console.log(productObj)
        await addDoc(collection(dbService, "productlist"), productObj);
    }
    const [inputs, setInputs] = useState({
        id:"",
        name: "",
        num: "",
        size: "",
        type: "",
        desc: "",
        pw: "",
        wheels: "",
        weight:""
    });

    const {id, name, num, desc, pw, weight} = inputs;

    useEffect(()=>{
        window.scrollTo(0, 0);
        setInputs({
            ...inputs,
        })
    }, [])

    const onChange = (e) => {
        const {name, value} = e.target;
        setInputs({
            ...inputs,
            [name]: value,
        })
    }

    const [tsa, setTsa] = useState(true);
    const getTsa = () => {
        setTsa(!tsa);
    }

    const [extension, setExtension] = useState(false);
    const getExtension = () => {
        setExtension(!extension);
    }

    const [sidehandle, setSidehandle] = useState(false);
    const getSidehandle = () => {
        setSidehandle(!sidehandle);
    }

    const [zip, setZip] = useState(false);
    const getZip = () => {
        setZip(!zip);
    }

    const [attachment, setAttachment] = useState("");

    const onFileChange = (event) => {
        const {
            target: { files }
        } = event;
        const theFile = files[0];
        const reader = new FileReader();
        reader.onloadend = (finishedEvent) => {
            const {currentTarget : {result}} = finishedEvent;
            setAttachment(result)
        }
        reader.readAsDataURL(theFile);
    };
    const fileInput = useRef();
    const onClearAttachment = () => {
        fileInput.current.value = "";
        setAttachment("");
    }
    return (
        <>
        <Navigation userObj={userObj} isLoggedIn={isLoggedIn} />
        <section className="page-section" id="createProduct">
            <div className="container">
                <div className="text-center">
                    <h2 className="section-heading">캐리어 등록</h2>
                    <div className="row text-center">
                        <form ref={form} onSubmit={postProduct}>
                            <table border="solid" width="100%" className={styles.orderTable}>
                                <thead>
                                    <tr>
                                        <th width="20%">ID</th>
                                        <td width="80%">
                                            <input type="text" name='id' value={id} className={styles.input} onChange={onChange} required />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>번호</th>
                                        <td>
                                            <input type="text" name='num' id='num' value={num} className={styles.input} onChange={onChange} required />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>이름</th>
                                        <td>
                                            <input type="text" name='name' value={name} className={styles.input} onChange={onChange} required />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>타입</th>
                                        <td>
                                            <select name='type' id='type' className={styles.select} onChange={onChange} required>
                                                <option>타입</option>
                                                <option value="기내용/소형">기내용/소형</option>
                                                <option value="화물용/중형">화물용/중형</option>
                                                <option value="화물용/대형">화물용/대형</option>
                                                <option value="미니캐리어">미니캐리어</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>사이즈</th>
                                        <td>
                                            <select name='size' id='size' onChange={onChange} className={styles.select} required>
                                                <option>사이즈</option>
                                                <option value="20">20인치</option>
                                                <option value="24">24인치</option>
                                                <option value="26">26인치</option>
                                                <option value="28">28인치</option>
                                                <option value="14">14인치</option>
                                            </select>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>바퀴갯수</th>
                                        <td>
                                            <select name='wheels' id='wheels' className={styles.select} onChange={onChange} required>
                                                <option>바퀴</option>
                                                <option value="4">4개</option>
                                                <option value="2">2개</option>
                                                <option value="0">0개</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>비밀번호</th>
                                        <td>
                                            <input type="text" name='pw' id='pw' value={pw} className={styles.input} onChange={onChange} placeholder="000" required />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>무게</th>
                                        <td>
                                            <input type="text" name='weight' id='weight' value={weight} className={styles.input} onChange={onChange} placeholder="000" required />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>특징</th>
                                        <td>
                                            <input type="text" name='desc' id='desc' value={desc} onChange={onChange} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>지퍼/원터치</th>
                                        <td>
                                            <label htmlFor="zip">
                                                <input type="checkbox" name='zip' id='zip' value={zip} onClick={getZip} />
                                                지퍼
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>확장여부</th>
                                        <td>
                                            <label htmlFor="extension">
                                                <input type="checkbox" id='extension' name='extension' value={extension} onClick={getExtension} />
                                                확장가능
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>측면손잡이</th>
                                        <td>
                                            <label htmlFor="sidehandle">
                                                <input type="checkbox" name='sidehandle' id='sidehandle' value={sidehandle} onClick={getSidehandle} />
                                                측면손잡이 있음
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>TSA락</th>
                                        <td>
                                            <label htmlFor="tsa">
                                                <input type="checkbox" name='tsa' id='tsa' value={tsa} onClick={getTsa} />
                                                TSA락 있음
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>캐리어사진</th>
                                        <td>
                                            <input type="file" name='imgs' id='imgs' ref={fileInput} accept="image/*" onChange={onFileChange} multiple />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <input type="submit" name="submit" className="btn" value="업로드" />
                        </form>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}

export default CreateProduct;